module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/744b6ed03870f04486df881f30e2a8da.png";